// Picks the right chart for a given dimension's expanded card body.
//
// Inequality / Poverty -> per-measure index tables (#259 / #260).
// Household income -> Decile. Others fall back to a small placeholder
// until their charts land.

import type { DimensionKey } from "../../lib/dimensions";
import type { EngineOutput } from "../../lib/types";
import { BudgetWaterfall } from "./budget_waterfall";
import { DecileChart } from "./decile_chart";
import { EffectiveTaxRate } from "./effective_tax_rate";
import { InequalityIndices } from "./inequality_indices";
import { PovertyIndices } from "./poverty_indices";
import { TaxBurdenStack } from "./tax_burden_stack";

interface Props {
  dimensionKey: DimensionKey;
  engineOutput: EngineOutput;
  baselineOutput: EngineOutput | null;
  isModified: boolean;
}

export function DimensionChart({
  dimensionKey,
  engineOutput,
  baselineOutput,
  isModified,
}: Props): JSX.Element {
  switch (dimensionKey) {
    case "inequality":
      return (
        <InequalityIndices
          engineOutput={engineOutput}
          baselineOutput={baselineOutput}
          isModified={isModified}
        />
      );
    case "household_income":
      return (
        <DecileChart
          engineOutput={engineOutput}
          baselineOutput={baselineOutput}
          isModified={isModified}
        />
      );
    case "tax_burden":
      return (
        <TaxBurdenStack
          engineOutput={engineOutput}
          baselineOutput={baselineOutput}
          isModified={isModified}
        />
      );
    case "redistribution":
      return (
        <EffectiveTaxRate
          engineOutput={engineOutput}
          baselineOutput={baselineOutput}
          isModified={isModified}
        />
      );
    case "state_budget":
      return (
        <BudgetWaterfall
          engineOutput={engineOutput}
          baselineOutput={baselineOutput}
          isModified={isModified}
        />
      );
    case "poverty":
      return (
        <PovertyIndices
          engineOutput={engineOutput}
          baselineOutput={baselineOutput}
          isModified={isModified}
        />
      );
    default:
      return (
        <div className="beamm-dimension-chart-placeholder">
          A dedicated chart for this dimension is coming next.
        </div>
      );
  }
}
